/** @file Skin by index, or NOT_FOUND at the caller's input path (shared by combineSkins and resolveSkin). */
import type { SkeletonData, SkinData } from '../skeletonData';
import { coreFail } from './coreFail';

/** data.skins[index]; throws NOT_FOUND (kind 'skin', ref = the index as a string) at `path` when absent. */
export function skinAt(data: SkeletonData, index: number, path: string): SkinData {
  const ref = String(index);
  return data.skins[index] ?? coreFail('NOT_FOUND', `skin "${ref}" not found`, { params: { kind: 'skin', ref }, path });
}
